import { useEffect, useState } from "react";
import { _ProcedureImp, _single } from "../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { ExcecuteRemoteAbstract } from "../system/remoteAbstractAction/ExcecuteRemoteAbstract";
import { BasicButton } from "../theme/Component/BasicButton";
import { PrintJson } from "../theme/Component/PrintJson";


interface Props {
    action: any;
    exportMap: any;
}
export const RenderJavaForm = ({ action, exportMap }: Props) => {

    const { instance } = useDataBean(_ProcedureImp);

    const [remote, setRemote] = useState<any>({});
    const [properties, setProperties] = useState<any>({});
    const [processBpm, setProcessBpm] = useState<any>({});
    const [lastStep,setLastStep] = useState<boolean>(false);

    useEffect(() => {
        if (action.FormEngine) {
            instance.getRemoteAbstractActionByClassForName(action.FormEngine).then(
                (resp: any) => {
                    setRemote(resp);
                    getRequestProcessBpmByImp();
                }
            )
        }
    }, [action])

    const getRequestProcessBpmByImp=()=>{
        instance.getRequestProcessBpmByImp(action.IDProcedureImp).then(
            (resp:any)=>{
                setProcessBpm(resp);
            }
        )
    }

    const finalizarForm = () => {
        let data = {
            executeDate: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID(),
            JavaFormType:"true"
        }
        exportMap(data);
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <h6>{remote.Name}</h6>
            </div>
            <div className="col-md-12">
                
                {processBpm.IDRequestTypeBpm > 0 &&

                    <ExcecuteRemoteAbstract remoteAbstractAction={remote} returnProps={setProperties} mapData={JSON.parse(processBpm.JSONProps ?? "{}") } action={action} lastStep={setLastStep} />

                }
            </div>
            <div className="col-md-6">
                {lastStep &&
                <BasicButton icon="" eventClick={finalizarForm}>Finalizar</BasicButton>
                }
            </div>
        </div>
    )
}